import { decodeJwt } from './accessRight';
import { getStorage } from './localstorage';

const normalizeAccessValue = (value) => String(value || '').trim().toLowerCase();

export const isDashboardFlagEnabled = () => process.env.REACT_APP_ENABLE_DASHBOARD === 'true'
  || (process.env.NODE_ENV === 'development'
    && process.env.REACT_APP_ENABLE_DASHBOARD !== 'false');

export const getDashboardAllowedUsers = () => String(process.env.REACT_APP_DASHBOARD_ALLOWED_USERS || '')
  .split(',')
  .map(normalizeAccessValue)
  .filter(Boolean);

export const isCurrentUserAllowedForDashboard = () => {
  const token = getStorage('token');
  const allowedUsers = getDashboardAllowedUsers();

  if (!token || !allowedUsers.length) return false;

  try {
    const decoded = decodeJwt(token);
    const currentUserKeys = [
      decoded?.EMAIL,
      decoded?.email,
      decoded?.ONE_ID,
      decoded?.one_id,
      decoded?.ONEID,
    ]
      .map(normalizeAccessValue)
      .filter(Boolean);

    return currentUserKeys.some((key) => allowedUsers.includes(key));
  } catch (error) {
    return false;
  }
};

export const canAccessDashboard = () => (
  isDashboardFlagEnabled() || isCurrentUserAllowedForDashboard()
);

export const shouldShowDashboardMenu = () => canAccessDashboard();
